<template>
	<div>
		<br />
		<div class="col-sm-12 text-right">
			<h1>Cobranzas</h1>
		</div>
		<br />

		<div class="d-flex flex-wrap">
      <div v-for="item in userMenu" :key="item.route_name" class="col-md-4">
        <div class="bpb-card">
          <div class="card-body">
            <div class="text-center">
              <img :src="item.img.src" :alt="item.img.alt" width="80px" />
            </div>
            <h4 class="card-title">{{ item.title }}</h4>
            <p class="card-subtitle text-muted" v-if="item.subtitle">{{ item.subtitle }}</p>
            <router-link :class="item.disabled && 'disabled'" :to="{name: item.route_name}" class="btn complementary-btn">Acceder</router-link>
          </div>
        </div>
      </div>
		</div>


	</div>
</template>

<script type="text/javascript">
	export default {
    data(){
      return {
        itemsMenu: [
          {
            disabled: false,
            app: 'cobranzas',
            route_name: 'cobranzas_index',
            title: 'Cobranzas',
            subtitle: 'Administración de cobranzas',
            permisos_validacion: 'ver_cobranzas',
            img: { src: 'https://static.bienparabien.com/constelacion/img/solicitudes.png', alt: 'Cobranzas' }
          },
          {
            disabled: false,
            app: 'cobranzas',
            route_name: 'cobranzas_listas',
            title: 'Listas',
            subtitle: 'Administración de listas de la aplicación',
            permisos_validacion: 'ver_listas',
            img: { src: 'https://static.bienparabien.com/constelacion/img/list_01_b.png', alt: 'Listas' }
          },
          {
            disabled: false,
            app: 'cobranzas',
            route_name: 'cobranzas_usuarios',
            title: 'Usuarios',
            subtitle: 'Administración de datos de usuarios de aplicación de cobranza',
            permisos_validacion: 'ver_usuarios',
            img: { src: 'https://static.bienparabien.com/constelacion/img/account_usuarios.png', alt: 'Usuarios' }
          },
        ],
        userMenu: [],
      }
    },
		mounted: function() {
			let menu = {title: 'Cobranzas Admin'};
			this.$store.commit('setMenu',[menu]);
      this.loadMenu(menu);
		},
    methods: {
      loadMenu(menu){
        for (const item of this.itemsMenu) {
         if (this.$auth.can(item.app, item.permisos_validacion) && !item.disabled) {
           this.userMenu.push(item);
           menu[item.route_name] = item.title;
         }
        }
      }
    }
	}
</script>
